import { useCardLayoutContext } from "../../../../contexts/CardLayoutContext";
import { LoadingScreen } from "../../../LoadingScreen";
import RealtimeVisualChart from "../../../charts/RealtimeVisualChart";

export const CardTileBody = ({ card, visual, runtime = null }) => {

    const {
        isDragging
    } = useCardLayoutContext();

    const vid = String(visual?.VisualId ?? visual?.visualId ?? "");

    return (
        <div className={`card-tile-body`}>
            <LoadingScreen isLoading={vid && (isDragging === vid)} fadeIn={true} />
            {vid && !(isDragging === vid) ? (
                <RealtimeVisualChart
                    chartKey={`card-chart-${visual?.VisualTypeId ?? visual?.VisualId ?? visual?.UniqueId ?? "new"}`}
                    runtime={runtime}
                    style={{ width: "100%", height: "100%" }}
                />
            ) : null}
        </div>
    )
}
